<template>
  <header-middle></header-middle>
  <!-- <img />  -->
  <div class="container">
    <h1 class="text-center my-4" style="font-weight: 700;">کسب درآمد به سبک راداَپ!</h1>
    <div class="my-4 text-center">
      <img src="https://radap.ir/imagesUploaded/main/Invation.jpg" alt="قوانین و مقررات" class='rounded' />
    </div>
    <div class="d-flex justify-content-between align-items-end">
      <h2 style="font-weight: 700;">چرا راداَپ؟</h2>
      <small class="pe-2" style="font-size: 12px;"><svg style="width: .8rem;" width="1.125rem" height="1.125rem" viewBox="0 0 18 18" fill="#676A70"><path data-v-995d9d2c="" fill-rule="evenodd" clip-rule="evenodd" d="M8.99984 0.666016C13.6022 0.666016 17.3332 4.39698 17.3332 8.99935C17.3332 13.6017 13.6022 17.3327 8.99984 17.3327C4.39746 17.3327 0.666504 13.6017 0.666504 8.99935C0.666504 4.39698 4.39746 0.666016 8.99984 0.666016ZM8.99984 2.33268C5.31794 2.33268 2.33317 5.31745 2.33317 8.99935C2.33317 12.6812 5.31794 15.666 8.99984 15.666C12.6817 15.666 15.6665 12.6812 15.6665 8.99935C15.6665 5.31745 12.6817 2.33268 8.99984 2.33268ZM8.99984 3.99935C9.4272 3.99935 9.77943 4.32105 9.82756 4.7355L9.83317 4.83268V8.72935L11.9197 9.9462C12.2889 10.1615 12.431 10.6169 12.2638 10.9991L12.2197 11.0859C12.0043 11.4551 11.549 11.5972 11.1667 11.43L11.0799 11.3858L8.57995 9.9275C8.35238 9.79475 8.2027 9.56344 8.17225 9.30551L8.1665 9.20768V4.83268C8.1665 4.37245 8.5396 3.99935 8.99984 3.99935Z"></path></svg> ۲ دقیقه</small>
    </div>
    <br />
    <p><b>راداَپ</b> یک پلتفرم فروش آنلاین محصولات سوپرمارکتی، لبنیات، رستوران، میوه و ... هستش.</p>
    <p><b>راداَپ</b> با یکسری فروشگاه قرارداد داره و محصولات فروشگاه های مختلف رو با همون قیمت درب فروشگاه برای مشتری ارسال میکنه و اینجا مشتری در واقع با همون قیمت درب فروشگاه محصول رو دریافت کرده که عالیه اما این پایان داستان نیست!</p>
    <img src="https://radap.ir/imagesUploaded/other/benefit3.jpg" class="rounded mb-3"/>

    <p style="font-weight: 700;">میپرسین مگه چیز دیگه ای هم مونده...؟!</p>
    <p>بله؛ مهمترین مزیت <b>راداَپ</b> تنها ارسال با قیمت درب فروشگاه نیست بلکه <u>تقسیم سود خودش با کاربرانش هست</u>.</p>
    <p style="font-weight: 700;">یعنی چی و چطور؟</p>
    <p>شما زمانی که از خدمات <b>راداَپ</b> استفاده کردید و پس از احساس رضایت و اطمینان از خدمات <b>راداَپ</b>، میتونید از همین قسمت کد معرف خودتون رو برای عزیزانتون به اشتراک بگذارید.</p>
    <img src="https://radap.ir/imagesUploaded/other/benefit1.jpg" class="rounded mb-3"/>

    <p style="font-size: 14px">نکته : البته اول باید در سایت <b>راداَپ</b> <span style="color:blue" @click="goToLogin(1)">  ورود</span>|<span @click="goToLogin(2)" style="color:blue">ثبت نام</span> کرده باشید.</p>
    <p>پس از ارسال کد معرف شما به دوستانتون و عضویت اونها در <b>راداَپ</b> از طریق پیامک به شما اطلاع داده میشه و همینطور از قسمت حساب کاربری میتونید از <span @click="goBenefit" style="color:blue;">زبانه کسب درآمد</span>|دوستان من، تعداد افراد دعوت شده توسط خودتون رو مشاهده کنید.</p>
    <p>حالا بعد از عضویتشون، شما <b> ۵۰درصد</b> از مراحل رو طی کردید.</p>
    <p style="font-size: 14px">نکته : افرادی که با کد معرف شما عضو خانواده <b>راداَپ</b> میشن به محض ثبت نام <b>۱۰,۰۰۰</b> تومان اعتبار هدیه میگیرند.</p>
    <b>وقت اقدامه :</b>
    <p>حالا هم شما و هم  تیم <b>راداَپ</b> با تبلیغاتی که انجام میده سعی میکنه کاربر دعوت شده توسط شخص شما رو مجاب به استفاده از خدمات فوق العاده <b>راداَپ</b> کنه و به محض اینکه خریدی توسط ایشان انجام بشه <b>۵۰درصد</b> از سود <b>راداَپ</b> مستقیم به اعتبار کیف پول شما افزوده خواهد شد و شما میتونید از طریق پیامک و یا قسمت حساب کاربری| <span @click="goBenefit" style="color:blue;">زبانه کسب درآمد</span>، درآمد های خودتون رو مشاهده کنید. </p>
    <img src="https://radap.ir/imagesUploaded/other/benefit.jpg" class="rounded mb-3"/>

    <p>یادتون باشه هرچه تعداد افراد بیشتری رو به خانواده <b>راداَپ</b> دعوت کنید در میزان سود بیشتری سهیم خواهید شد که هم میتونید از این اعتبار جهت خرید های روزانه خودتون استفاده کنید یا به حساب بانکیتون واریز کنید.</p>
    <p style="font-weight: 700;">راداَپی بودن یه حس خوبه، یه خرید متفاوت 😉</p>
    <br />
    <small>#راد_اَپ #کسب_درآمد #حس خوب</small>
  </div>
  <div class="prcol-md-6" v-if="auth.token">
    <div class="prow py-3 container">
      <div class="prcol-md-12">
        <div class="">
          <span class="h3">۱۵ امتیاز هدیه دعوت دوستان</span>
        </div>
        <p class="prsmall-text prcolor-text mt-1">با دعوت از دوستان‌تان از طریق کد زیر، امتیاز باشگاه مشتریان را
          دریافت کنید.</p>
        <div >
          <div class="search-input">
            <span id="myTooltipTemp "
                  style="display:block;width:100%;text-align:center;background-color:red;font-weight:bold;border-radius: 5px;">{{ tooltipText }}</span>
            <input type="text" class="form-control prrounded prborder prcolor-text inviteLinkInput" style="direction:ltr;"
              id="inviteLinkTemp1" readonly="" :value="'https://radap.ir/Invite/'+auth.token">
            <button class="btn btn-info w-100 mt-2" @click="copyLink">کپی کردن</button>
          </div>
        </div>
        <div class="prtext-center py-2 m-auto">
          <p class="h3 mt-3">به اشتراک گذاری</p>
          <small class="d-block mb-3">کد معرفتان را از طریق لینک های زیر با دوستانتان به اشتراک بگذارید</small>
          <button class="btn btn-success w-100" @click="shareLink">
                اشتراک گذاری<i class="bi bi-share"></i>
              </button>
        </div>
      </div>
    </div>
  </div>
  <!--  <grid-template /> -->
  <footer-template />
</template>
  
<script setup>
import HeaderMiddle from '../section/header/header.vue'
import GridTemplate from "../section/footer/grids.vue";
import FooterTemplate from "../section/footer/footer.vue";
import { ref } from 'vue';
import router from '@/router';
import { alertBox } from '@/composables/silverBox';
import { useAuth } from '@/store/auth'
import axios from 'axios'
let auth = useAuth()
let tooltipText = ref()
let reagentCode = ref()
let proFlag = ref()


function copyLink() {
  var copyText = document.getElementById("inviteLinkTemp1");
  copyText.select();
  copyText.setSelectionRange(0, 99999);
  document.execCommand('copy');
  tooltipText.value = 'کپی  شد ...';
  setTimeout(() => { tooltipText.value = ''; }, 600);

}
async function shareLink() {
  auth.getToken()
  reagentCode.value = 'https://radap.ir/Invite/'+auth.token
  const shareData = {
    title: "لینک معرفی",
    text: 'سلام، با راداَپ ضمن تهیه مایحتاج روزانت با قیمت مناسب و ارسال سریع درآمد هم داشته باش،روی کد دعوت من بزن و با ثبت نام در راداَپ 10.000 تومان اعتبار هدیه بگیر، حس خوب خرید با راداَپ',
    url: reagentCode.value
  };
  try {
    await navigator.share(shareData);
  } catch (err) {
    alert(err);
  }
}
function goToLogin(type) {
  if(type == 1){
    document.querySelector('#loginsModalBTN').click();
  }else{
    document.querySelector('#mobileModalBTN').click()
  }
}
function goBenefit(){
  validLogin()
  if(proFlag.value){
    router.push('/Account#benefits')
  }else{
    silverBox({
					html : '<div class="text-center" >برای مشاهده این قسمت ابتدا باید وارد شوید.<div>',
					centerContent: true,
					direction: "rtl",
					closeOnOverlayClick :false,
					cancelButton: {
						borderColor: "green",
						className: "w-50 bg-success mx-auto text-light",
						closeOnClick: true,
						loadingAnimation: true,
						showButton: true,
						text: "متوجه شدم",
						textColor: "",
					},
				});
  }
}


function validLogin() {
  auth.getToken()
  let profile = auth.token
  if (profile) {
    proFlag.value = true;
  } else {
    proFlag.value = false;
  }
}
</script>
  
<style scoped>
p {
  letter-spacing: 0 !important;
  font-size: 16px;
  font-family: 'Sahel';
  text-align: justify;
}
</style>